import React from 'react'
import PropTypes from 'prop-types'

import PaymentDueDialog from './PaymentDueDialog'

export default class PaymentDueInput extends React.Component {
  
  static propTypes = {
    billEditor: PropTypes.object.isRequired,
    billingEntity: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      openDialog: false
    }
  }

  handleInputClicked = event => {
    event.preventDefault()
    this.setState({
      openDialog: true,
      anchorElement: event.currentTarget
    })
  }

  handleCloseRequested = () => {
    this.setState({
      openDialog: false
    })
  }

  handleDateSelected = date => {
    this.props.billEditor.setPaymentDueDate(date)
    this.setState({
      openDialog: false
    })
  }

  render() {
    const dueDateStr = this.props.billEditor.getPaymentDueDate()
      ? this.props.billEditor.getPaymentDueDate().format('MMM Do, YYYY')
      : ''
    return (
      <div>
        <input
          style={styles.input}
          value={dueDateStr}
          readOnly={true}
          onClick={this.handleInputClicked} />
        <PaymentDueDialog
          open={this.state.openDialog}
          billDate={this.props.billEditor.getBillDate()}
          billingEntity={this.props.billingEntity}
          anchorElement={this.state.anchorElement}
          onCloseRequested={this.handleCloseRequested}
          onDateSelected={this.handleDateSelected} />
      </div>
    )
  }

}

const styles = {
  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    color: '#4a4a4a',
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    outlineWidth: 2
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/header/paymentDue/PaymentDueInput.js